export const ADMIN_OPERATOR_MODE_CONFIG = {
  dcg: {
    key: "dcg",
    name: "Dream Car Giveaways",
    domain: "dreamcargiveaways.co.uk",
    mode: "trusted_auto",
    modeLabel: "Trusted automation",
    tone: "ok",
    summary: "Trusted baseline operator. Scan/apply/verify/publish/expire follow backend flags.",
    supportedActions: ["Scheduled operator automation", "DCG V2 manual refresh", "Notifications"],
    supports: {
      trustedAutomation: false,
      dcgV2: true,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  llf: {
    key: "llf",
    name: "LLF Games",
    domain: "llfgames.com",
    mode: "apply_verify_publish",
    modeLabel: "Apply + verify + publish",
    tone: "info",
    summary: "LLF Games uses exact source identities, immutable-snapshot preflight/apply, exact-set verify/publish, guarded same-product expiry and scheduled maintenance. Publish, Expiry and Scheduler remain disabled by default.",
    supportedActions: ["Dry-run public-source scan", "Immutable apply preflight", "Apply exact safe drafts", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded hide-only expiry", "Scheduled maintenance", "Source and odds diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: false,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: false,
      operatorAutomationScheduler: false,
      searchIndex: false,
    },
  },
  kilted: {
    key: "kilted",
    name: "Kilted Competitions",
    domain: "kiltedcompetitions.co.uk",
    mode: "manual_only",
    modeLabel: "Manual only",
    tone: "info",
    summary: "Kilted uses exact WooCommerce product identities, immutable-snapshot apply, exact-set verify/publish, awareness-only separation and guarded same-product expiry. Every capability is disabled by default.",
    supportedActions: ["Dry-run current-catalogue scan", "Immutable apply preflight", "Apply exact safe drafts", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded hide-only expiry", "Scheduled maintenance", "Source and odds diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  ukcc: {
    key: "ukcc",
    name: "UKCC Competitions",
    domain: "ukcc.co.uk",
    mode: "manual_only",
    modeLabel: "Manual only",
    tone: "info",
    summary: "UKCC uses exact API draw identities, immutable-snapshot apply, exact-set verify/publish, awareness-only separation and guarded same-product expiry. Every capability is disabled by default.",
    supportedActions: ["Dry-run current-catalogue scan", "Immutable apply preflight", "Apply exact safe drafts", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded hide-only expiry", "Scheduled maintenance", "Source and odds diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  bounty: {
    key: "bounty",
    name: "Bounty Competitions",
    domain: "bountycompetitions.co.uk",
    mode: "manual_only",
    modeLabel: "Manual only",
    tone: "info",
    summary: "Bounty uses exact Livewire product identities, immutable-snapshot apply, exact-set verify/publish, awareness-only separation and guarded same-product expiry. Every capability is disabled by default.",
    supportedActions: ["Dry-run current-catalogue scan", "Immutable apply preflight", "Apply exact safe drafts", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded hide-only expiry", "Scheduled maintenance", "Source and odds diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  apex: {
    key: "apex",
    name: "Apex Competitions",
    domain: "apex-competition.co.uk",
    mode: "manual_only",
    modeLabel: "Manual only",
    tone: "info",
    summary: "Apex uses exact Livewire product identities, immutable-snapshot apply, exact-set verify/publish, awareness-only separation and guarded same-product expiry. Every capability is disabled by default.",
    supportedActions: ["Dry-run current-catalogue scan", "Immutable apply preflight", "Apply exact safe drafts", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded hide-only expiry", "Scheduled maintenance", "Source and odds diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  jammy: {
    key: "jammy",
    name: "JAMMY",
    domain: "jammy.co.uk",
    mode: "manual_only",
    modeLabel: "Manual only",
    tone: "info",
    summary: "JAMMY uses exact Woo product identities, current-taxonomy reconciliation, immutable-snapshot apply, exact-set verify/publish, awareness-only separation and guarded same-product expiry. Every capability is disabled by default.",
    supportedActions: ["Dry-run current-catalogue scan", "Immutable apply preflight", "Apply exact safe drafts", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded hide-only expiry", "Scheduled maintenance", "Source and odds diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  pawsome: {
    key: "pawsome",
    name: "Pawsome Competitions",
    domain: "pawsomecomps.com",
    mode: "manual_only",
    modeLabel: "Manual only",
    tone: "info",
    summary: "Pawsome uses exact Woo product identities, current-taxonomy reconciliation, immutable-snapshot apply, exact-set verify/publish, awareness-only separation and guarded same-product expiry. Every capability is disabled by default.",
    supportedActions: ["Dry-run current-catalogue scan", "Immutable apply preflight", "Apply exact safe drafts", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded hide-only expiry", "Scheduled maintenance", "Source and odds diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  lincolnshire: {
    key: "lincolnshire",
    name: "Lincolnshire Competitions",
    domain: "lincolnshire-competitions.co.uk",
    mode: "manual_only",
    modeLabel: "Manual only",
    tone: "info",
    summary: "Lincolnshire uses exact Woo product identities across its current operator-owned taxonomies, immutable-snapshot apply, exact-set verify/publish, awareness-only separation and guarded same-product expiry. Every capability is disabled by default.",
    supportedActions: ["Dry-run current-catalogue scan", "Immutable apply preflight", "Apply exact safe drafts", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded hide-only expiry", "Scheduled maintenance", "Source and odds diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  drift: {
    key: "drift",
    name: "Drift Competitions",
    domain: "driftcompetitions.co.uk",
    mode: "manual_only",
    modeLabel: "Manual only",
    tone: "info",
    summary: "Drift uses exact Woo product identities across its current operator-owned taxonomies, immutable-snapshot apply, exact-set verify/publish, awareness-only separation and guarded same-product expiry. Every capability is disabled by default.",
    supportedActions: ["Dry-run current-catalogue scan", "Immutable apply preflight", "Apply exact safe drafts", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded hide-only expiry", "Scheduled maintenance", "Source and odds diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  palladium: {
    key: "palladium",
    name: "Palladium Competitions",
    domain: "palladiumcompetitions.com",
    mode: "manual_only",
    modeLabel: "Manual only",
    tone: "info",
    summary: "Palladium uses exact Woo product identities from its complete current catalogue, immutable-snapshot apply, exact-set verify/publish, awareness-only separation and guarded same-product expiry. Every capability is disabled by default.",
    supportedActions: ["Dry-run current-catalogue scan", "Immutable apply preflight", "Apply exact safe drafts", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded hide-only expiry", "Scheduled maintenance", "Source and odds diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  pristine: {
    key: "pristine",
    name: "Pristine Competitions",
    domain: "pristinecompetitions.co.uk",
    mode: "manual_only",
    modeLabel: "Manual only",
    tone: "info",
    summary: "Pristine uses exact Woo product identities from its complete paginated catalogue, immutable-snapshot apply, exact-set verify/publish, awareness-only separation and guarded same-product expiry. Every capability is disabled by default.",
    supportedActions: ["Dry-run current-catalogue scan", "Immutable apply preflight", "Apply exact safe drafts", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded hide-only expiry", "Scheduled maintenance", "Source and odds diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  caddy: {
    key: "caddy",
    name: "Caddy Comps",
    domain: "caddycomps.com",
    mode: "manual_only",
    modeLabel: "Manual only",
    tone: "info",
    summary: "Caddy uses exact Woo product identities from its operator-owned open feed, immutable-snapshot apply, exact-set verify/publish, awareness-only separation and guarded same-product expiry. Every capability is disabled by default.",
    supportedActions: ["Dry-run current-catalogue scan", "Immutable apply preflight", "Apply exact safe drafts", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded hide-only expiry", "Scheduled maintenance", "Source and odds diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  hotcomps: {
    key: "hotcomps",
    name: "Hot Comps",
    domain: "hotcomps.com",
    mode: "manual_only",
    modeLabel: "Manual only",
    tone: "info",
    summary: "Hot Comps reconciles exact Woo product identities across its Store API and current homepage, with immutable-snapshot apply, exact-set verify/publish, awareness-only separation and guarded same-product expiry. Every capability is disabled by default.",
    supportedActions: ["Dry-run current-catalogue scan", "Immutable apply preflight", "Apply exact safe drafts", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded hide-only expiry", "Scheduled maintenance", "Source and odds diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  thatprizeguy: {
    key: "thatprizeguy",
    name: "That Prize Guy",
    domain: "thatprizeguy.co.uk",
    mode: "manual_only",
    modeLabel: "Manual only",
    tone: "info",
    summary: "That Prize Guy uses exact Livewire product identities, immutable-snapshot apply, exact-set verify/publish, awareness-only separation and guarded same-product expiry. Every capability is disabled by default.",
    supportedActions: ["Dry-run current-catalogue scan", "Immutable apply preflight", "Apply exact safe drafts", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded hide-only expiry", "Scheduled maintenance", "Source and odds diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  giveawayguys: {
    key: "giveawayguys",
    name: "The Giveaway Guys",
    domain: "thegiveawayguys.co.uk",
    mode: "manual_only",
    modeLabel: "Manual only",
    tone: "info",
    summary: "The Giveaway Guys uses exact WooCommerce product identities, immutable-snapshot apply, exact-set verify/publish, awareness-only separation and guarded same-product expiry. Every capability is disabled by default.",
    supportedActions: ["Dry-run current-catalogue scan", "Immutable apply preflight", "Apply exact safe drafts", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded hide-only expiry", "Scheduled maintenance", "Source and odds diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  bright: {
    key: "bright",
    name: "Bright Competitions",
    domain: "brightcompetitions.co.uk",
    mode: "manual_only",
    modeLabel: "Manual only",
    tone: "info",
    summary: "Bright uses exact Woo product identities from its operator-owned catalogue, immutable-snapshot apply, exact-set verify/publish, awareness-only separation and guarded same-product expiry. Every capability is disabled by default.",
    supportedActions: ["Dry-run current-catalogue scan", "Immutable apply preflight", "Apply exact safe drafts", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded hide-only expiry", "Scheduled maintenance", "Source and odds diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  salexmo: {
    key: "salexmo",
    name: "Salexmo",
    domain: "salexmo.co.uk",
    mode: "manual_only",
    modeLabel: "Manual only",
    tone: "info",
    summary: "Salexmo uses exact Livewire product identities, immutable-snapshot apply, exact-set verify/publish, awareness-only separation and guarded same-product expiry. Every capability is disabled by default.",
    supportedActions: ["Dry-run current-catalogue scan", "Immutable apply preflight", "Apply exact safe drafts", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded hide-only expiry", "Scheduled maintenance", "Source and odds diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  storm: {
    key: "storm",
    name: "Storm Competitions",
    domain: "stormcompetitions.co.uk",
    mode: "manual_only",
    modeLabel: "Manual only",
    tone: "info",
    summary: "Storm uses exact Woo product identities, immutable-snapshot apply, exact-set verify/publish, awareness-only separation and guarded same-product expiry. Every capability is disabled by default.",
    supportedActions: ["Dry-run current-catalogue scan", "Immutable apply preflight", "Apply exact safe drafts", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded hide-only expiry", "Scheduled maintenance", "Source and odds diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  redline: {
    key: "redline",
    name: "Redline Competitions",
    domain: "redline-competitions.com",
    mode: "manual_only",
    modeLabel: "Manual only",
    tone: "info",
    summary: "Redline uses exact Woo product identities, immutable-snapshot apply, exact-set verify/publish, awareness-only separation and guarded same-product expiry. Every capability is disabled by default.",
    supportedActions: ["Dry-run current-catalogue scan", "Immutable apply preflight", "Apply exact safe drafts", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded hide-only expiry", "Scheduled maintenance", "Source and odds diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  prizeparadise: {
    key: "prizeparadise",
    name: "Prize Paradise",
    domain: "prizeparadise.co.uk",
    mode: "manual_only",
    modeLabel: "Manual only",
    tone: "info",
    summary: "Prize Paradise uses exact Woo product identities, immutable-snapshot apply, exact-set verify/publish, awareness-only separation and guarded same-product expiry. Every capability is disabled by default.",
    supportedActions: ["Dry-run current-catalogue scan", "Immutable apply preflight", "Apply exact safe drafts", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded hide-only expiry", "Scheduled maintenance", "Source and odds diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  elite: {
    key: "elite",
    name: "Elite Competitions",
    domain: "elitecompetitions.co.uk",
    mode: "dry_run",
    modeLabel: "Dry-run only",
    tone: "info",
    summary: "Elite live-listing profile is available for dry-run inspection only.",
    supportedActions: ["Live-listing dry-run", "Extraction evidence"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: true,
      liveListingApply: false,
      operatorAutomation: true,
      searchIndex: false,
    },
  },
  revcomps: {
    key: "revcomps",
    name: "Rev Comps",
    domain: "revcomps.com",
    mode: "trusted_auto",
    modeLabel: "Trusted automation",
    tone: "ok",
    summary: "Rev Comps supports trusted scheduled full-catalogue Scan, Apply, Verify and Publish. Expiry remains a separate disabled control and is never invoked by the scheduled sequence.",
    supportedActions: ["Scheduled trusted Scan, Apply, Verify and Publish", "Full-catalogue automation scan", "Apply to review queue", "Verify pending records", "Publish verified drafts", "Guarded expiry diagnostics", "Advanced batch diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  botb: {
    key: "botb",
    name: "BOTB",
    domain: "botb.com",
    mode: "trusted_auto",
    modeLabel: "Trusted automation",
    tone: "info",
    summary: "BOTB uses scan diagnostics, controlled public-safe catalogue refresh, guarded hide-only expiry and scheduled refresh/expiry. Apply, verify, publish, affiliate links and cart/purchase integration stay disabled. Dream Car / Spot the Ball is skill-based with no standard odds; odds require strict BOTB trust evidence.",
    supportedActions: ["Scan diagnostics", "Public-safe catalogue refresh", "Expiry dry-run diagnostics", "Guarded live expiry", "Scheduled refresh/expiry", "Family classification", "Extraction evidence"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationExpiryDryRun: true,
      botbPublicCataloguePublish: true,
      operatorAutomationApply: false,
      operatorAutomationVerify: false,
      operatorAutomationPublish: false,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  "7days": {
    key: "7days",
    name: "7days Performance",
    domain: "7daysperformance.co.uk",
    mode: "apply_verify_publish",
    modeLabel: "Apply + verify + publish",
    tone: "info",
    summary: "7days API discovery supports admin dry-run scans, controlled draft apply, verify-only, publish-only, guarded expiry and trusted scheduled maintenance when explicitly enabled.",
    supportedActions: ["Dry-run API scan", "Apply draft review records", "Verify existing draft records", "Publish verified drafts and refresh images/cash alternatives", "Expiry dry-run diagnostics", "Guarded live expiry", "Scheduled maintenance", "Extraction diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: true,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  click: {
    key: "click",
    name: "Click Competitions",
    domain: "clickcompetitions.co.uk",
    mode: "trusted_auto",
    modeLabel: "Trusted automation",
    tone: "info",
    summary: "Click Competitions supports admin dry-run diagnostics, apply-only draft ingestion, verify-only promotion, publish-only for verified odds-safe drafts, guarded expiry and trusted scheduled maintenance when explicitly enabled. Instant/prize-pool mechanics remain quarantined.",
    supportedActions: ["Dry-run Next.js scan", "Apply display-only draft records", "Verify odds-safe drafts", "Publish verified odds-safe drafts", "Expiry dry-run diagnostics", "Guarded live expiry", "Scheduled trusted automation", "Display evidence diagnostics", "Winner/result diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: true,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpire: true,
      operatorAutomationScheduler: true,
      searchIndex: false,
    },
  },
  jonnyfromdonny: {
    key: "jonnyfromdonny",
    name: "Jonny From Donny",
    domain: "jonnyfromdonnycompetitions.co.uk",
    mode: "scan_only",
    modeLabel: "Scan dry-run only",
    tone: "info",
    summary: "Jonny From Donny feasibility scan. Scan only - no records created. Not trusted automation yet. Budget Odds disabled until extraction is verified.",
    supportedActions: ["Dry-run feasibility scan", "Extraction diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: true,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: false,
      operatorAutomationVerify: false,
      operatorAutomationPublish: false,
      operatorAutomationExpire: false,
      operatorAutomationScheduler: false,
      searchIndex: false,
    },
  },
  feelgood: {
    key: "feelgood",
    name: "Feel Good Competitions",
    domain: "feelgoodcompetitions.com",
    mode: "scan_only",
    modeLabel: "Scan dry-run only",
    tone: "info",
    summary: "Feel Good Competitions feasibility scan. Scan only - no records created. Not trusted automation yet. Budget Odds disabled until extraction is verified.",
    supportedActions: ["Dry-run feasibility scan", "Extraction diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: true,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: false,
      operatorAutomationVerify: false,
      operatorAutomationPublish: false,
      operatorAutomationExpire: false,
      operatorAutomationScheduler: false,
      searchIndex: false,
    },
  },
  aspire: {
    key: "aspire",
    name: "Aspire Competitions",
    domain: "aspirecomps.co.uk",
    mode: "apply_verify_publish",
    modeLabel: "Apply + verify + publish",
    tone: "info",
    summary: "Aspire Competitions supports immutable-snapshot preflight/apply, exact-set verify/publish, guarded managed-set expiry and a scheduled trusted sequence. Expiry and Scheduler remain disabled by default. Budget Odds requires paid trusted evidence.",
    supportedActions: ["Dry-run reachability scan", "Automated network discovery", "Immutable apply preflight", "Apply display-safe draft records", "Verify draft records", "Publish verified drafts", "Expiry dry-run diagnostics", "Guarded managed-set expiry", "Scheduled trusted sequence", "Extraction diagnostics"],
    supports: {
      trustedAutomation: false,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: true,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: false,
      operatorAutomationScheduler: false,
      searchIndex: false,
    },
  },
  mckinney: {
    key: "mckinney",
    name: "McKinney Competitions",
    domain: "mckinneycompetitions.com",
    mode: "apply_verify_publish",
    modeLabel: "Trusted automation ready",
    tone: "info",
    summary: "McKinney Competitions uses exact GBP evidence, immutable-snapshot preflight/apply, exact-set verify/publish, guarded managed-set expiry and a scheduled trusted sequence. Public exposure, Expiry and Scheduler remain disabled by default.",
    supportedActions: ["Dry-run public-source scan", "Immutable apply preflight", "Apply display-safe draft records", "Verify exact live set", "Publish verified exact set", "Expiry dry-run diagnostics", "Guarded managed-set expiry", "Scheduled trusted sequence", "GBP and mechanics diagnostics"],
    supports: {
      trustedAutomation: true,
      dcgV2: false,
      liveListingDryRun: false,
      liveListingApply: false,
      operatorAutomation: true,
      supportsScanDiagnostics: true,
      scanOnly: false,
      canRunScan: true,
      canRunWritePhases: false,
      operatorAutomationApply: true,
      operatorAutomationVerify: true,
      operatorAutomationPublish: false,
      operatorAutomationExpiryDryRun: true,
      operatorAutomationExpire: false,
      operatorAutomationScheduler: false,
      searchIndex: false,
    },
  },
};

const NAME_TO_KEY = {
  "dream car giveaways": "dcg",
  "llf games": "llf",
  "elite competitions": "elite",
  "rev comps": "revcomps",
  revcomps: "revcomps",
  botb: "botb",
  "click competitions": "click",
  "jonny from donny": "jonnyfromdonny",
  "jonny from donny competitions": "jonnyfromdonny",
  jonnyfromdonny: "jonnyfromdonny",
  "feel good": "feelgood",
  "feel-good": "feelgood",
  "feel good competitions": "feelgood",
  feelgood: "feelgood",
  "aspire competitions": "aspire",
  "aspire comps": "aspire",
  aspire: "aspire",
  "mckinney competitions": "mckinney",
  mckinney: "mckinney",
  "ukcc competitions": "ukcc",
  "uk carp competitions": "ukcc",
  ukcc: "ukcc",
  "bounty competitions": "bounty",
  bounty: "bounty",
  "storm competitions": "storm",
  storm: "storm",
  "redline competitions": "redline",
  redline: "redline",
  "prize paradise": "prizeparadise",
  prizeparadise: "prizeparadise",
  "apex competitions": "apex",
  apex: "apex",
  "jammy competitions": "jammy",
  jammy: "jammy",
  "pawsome competitions": "pawsome",
  pawsome: "pawsome",
  "lincolnshire competitions": "lincolnshire",
  lincolnshire: "lincolnshire",
  "drift competitions": "drift",
  drift: "drift",
  "palladium competitions": "palladium",
  palladium: "palladium",
  "pristine competitions": "pristine",
  pristine: "pristine",
  "caddy comps": "caddy",
  "caddy competitions": "caddy",
  caddy: "caddy",
  "hot comps": "hotcomps",
  "hot comps competitions": "hotcomps",
  hotcomps: "hotcomps",
  "that prize guy": "thatprizeguy",
  thatprizeguy: "thatprizeguy",
  "the giveaway guys": "giveawayguys",
  "giveaway guys": "giveawayguys",
  giveawayguys: "giveawayguys",
  "bright competitions": "bright",
  bright: "bright",
  salexmo: "salexmo",
  "7days performance": "7days",
  "7 days performance": "7days",
};

const DOMAIN_TO_KEY = [
  ["dreamcargiveaways.co.uk", "dcg"],
  ["llfgames.com", "llf"],
  ["elitecompetitions.co.uk", "elite"],
  ["revcomps.com", "revcomps"],
  ["botb.com", "botb"],
  ["7daysperformance.co.uk", "7days"],
  ["clickcompetitions.co.uk", "click"],
  ["jonnyfromdonnycompetitions.co.uk", "jonnyfromdonny"],
  ["feelgoodcompetitions.com", "feelgood"],
  ["aspirecomps.co.uk", "aspire"],
  ["mckinneycompetitions.com", "mckinney"],
  ["ukcc.co.uk", "ukcc"],
  ["bountycompetitions.co.uk", "bounty"],
  ["stormcompetitions.co.uk", "storm"],
  ["redline-competitions.com", "redline"],
  ["prizeparadise.co.uk", "prizeparadise"],
  ["apex-competition.co.uk", "apex"],
  ["jammy.co.uk", "jammy"],
  ["pawsomecomps.com", "pawsome"],
  ["lincolnshire-competitions.co.uk", "lincolnshire"],
  ["driftcompetitions.co.uk", "drift"],
  ["palladiumcompetitions.com", "palladium"],
  ["pristinecompetitions.co.uk", "pristine"],
  ["caddycomps.com", "caddy"],
  ["hotcomps.com", "hotcomps"],
  ["thatprizeguy.co.uk", "thatprizeguy"],
  ["thegiveawayguys.co.uk", "giveawayguys"],
  ["brightcompetitions.co.uk", "bright"],
  ["salexmo.co.uk", "salexmo"],
];

const MANUAL_ONLY_CONFIG = {
  key: "manual_only",
  mode: "manual_only",
  modeLabel: "Manual only",
  tone: "muted",
  summary: "No trusted automation or selected live-listing action is enabled for this operator.",
  supportedActions: ["Search-index tools where enabled"],
  supports: {
    trustedAutomation: false,
    dcgV2: false,
    liveListingDryRun: false,
    liveListingApply: false,
    operatorAutomation: false,
    searchIndex: true,
  },
};

function normalise(value) {
  return String(value || "").trim().toLowerCase();
}

function validRunTimestamp(value) {
  if (!value) return null;
  const timestamp = Date.parse(value);
  return Number.isFinite(timestamp) ? timestamp : null;
}

function latestOperatorRun(operator, settings) {
  const candidates = [
    {
      at: settings.last_run_at,
      status: settings.last_run_status ?? null,
      source: "automation",
    },
    {
      at: settings.last_scheduled_run_at,
      status: settings.last_scheduled_run_status ?? null,
      source: "scheduled_automation",
    },
    {
      at: operator.lastRunAt,
      status: operator.lastRunStatus ?? null,
      source: "legacy_ingest",
    },
  ].map((candidate) => ({
    ...candidate,
    timestamp: validRunTimestamp(candidate.at),
  })).filter((candidate) => candidate.timestamp !== null);

  return candidates.reduce((latest, candidate) => (
    !latest || candidate.timestamp > latest.timestamp ? candidate : latest
  ), null);
}

function operatorDomainBlob(operator = {}) {
  return [
    operator.canonical_domain,
    operator.website_url,
    operator.domain,
    ...(operator.known_alias_domains || []),
  ].filter(Boolean).join(" ").toLowerCase();
}

export function operatorModeKey(operator = {}) {
  const nameKey = NAME_TO_KEY[normalise(operator.name)];
  if (nameKey) return nameKey;
  const blob = operatorDomainBlob(operator);
  const match = DOMAIN_TO_KEY.find(([domain]) => blob.includes(domain));
  return match ? match[1] : "manual_only";
}

export function buildAdminOperatorOptions(operators = []) {
  const safeOperators = Array.isArray(operators) ? operators : [];
  const byKey = new Map();

  for (const operator of safeOperators) {
    const key = operatorModeKey(operator);
    const config = ADMIN_OPERATOR_MODE_CONFIG[key] || MANUAL_ONLY_CONFIG;
    const optionKey = config.key === "manual_only"
      ? `manual:${operator.id || operator.name}`
      : config.key;
    byKey.set(optionKey, {
      ...config,
      key: config.key,
      optionKey,
      name: operator.name || config.name,
      domain: operator.canonical_domain || operator.website_url || config.domain || "",
      operator,
      lastRunAt: operator.last_ingested_at || null,
      lastRunStatus: operator.last_ingest_status || null,
      lastRunLabel: "Last ingest",
      ingestEnabled: operator.ingest_enabled === true,
    });
  }

  for (const config of Object.values(ADMIN_OPERATOR_MODE_CONFIG)) {
    if (!byKey.has(config.key)) {
      byKey.set(config.key, {
        ...config,
        optionKey: config.key,
        operator: null,
        lastRunAt: null,
        lastRunStatus: null,
        lastRunLabel: "Last run",
        ingestEnabled: false,
      });
    }
  }

  return Array.from(byKey.values()).sort((a, b) => {
    const rank = { dcg: 0, llf: 1, elite: 2, revcomps: 3, botb: 4, "7days": 5, click: 6, jonnyfromdonny: 7, feelgood: 8, aspire: 9, mckinney: 10, kilted: 11, ukcc: 12, bounty: 13, storm: 14, redline: 15, prizeparadise: 16, apex: 17, jammy: 18, pawsome: 19, lincolnshire: 20, drift: 21, palladium: 22, pristine: 23, caddy: 24, hotcomps: 25, thatprizeguy: 26, giveawayguys: 27, bright: 28, salexmo: 29 };
    const aRank = rank[a.key] ?? 10;
    const bRank = rank[b.key] ?? 10;
    if (aRank !== bRank) return aRank - bRank;
    return a.name.localeCompare(b.name);
  });
}

const PAUSED_MODES = new Set(["paused", "disabled", "next_candidate", "manual_only"]);
const MODE_LABELS = {
  trusted_auto: "Trusted automation",
  apply_only: "Apply only",
  apply_verify: "Apply + verify",
  apply_verify_publish: "Apply + verify + publish",
  dry_run_only: "Dry-run only",
  scan_only: "Dry-run only",
  manual_only: "Manual only",
  paused: "Paused",
  disabled: "Disabled",
  next_candidate: "Next candidate",
};

export function mergeAutomationSettingsIntoOperator(operator, settings) {
  if (!operator || !settings) return operator;
  const latestRun = latestOperatorRun(operator, settings);
  const configuredMode = settings.mode_effective || settings.mode || operator.mode;
  const aspireLegacyMode = (
    operator.key === "aspire" && PAUSED_MODES.has(configuredMode)
  );
  let mode = configuredMode;
  if (operator.key === "7days" && PAUSED_MODES.has(mode)) {
    mode = "apply_verify_publish";
  }
  if (operator.key === "click" && PAUSED_MODES.has(mode)) {
    mode = "trusted_auto";
  }
  if (operator.key === "jonnyfromdonny" && PAUSED_MODES.has(mode)) {
    mode = "scan_only";
  }
  if (operator.key === "feelgood" && PAUSED_MODES.has(mode)) {
    mode = "scan_only";
  }
  if (operator.key === "aspire" && PAUSED_MODES.has(mode)) {
    mode = "apply_verify_publish";
  }
  if (operator.key === "mckinney" && PAUSED_MODES.has(mode)) {
    mode = "apply_verify_publish";
  }
  const paused = PAUSED_MODES.has(mode);
  const supports = { ...(operator.supports || {}) };

  if (operator.key === "dcg" || operator.key === "elite" || operator.key === "revcomps" || operator.key === "botb") {
    supports.liveListingDryRun = (
      operator.key === "elite"
      && !paused
      && settings.dry_run_enabled === true
    );
    supports.liveListingApply = false;
    supports.operatorAutomation = !paused && settings.scan_enabled === true;
    supports.operatorAutomationApply = (
      (operator.key === "dcg" || operator.key === "elite" || operator.key === "revcomps")
      && !paused
      && settings.apply_enabled === true
    );
    supports.operatorAutomationVerify = (
      (operator.key === "dcg" || operator.key === "revcomps")
      && !paused
      && settings.verify_enabled === true
    );
    supports.operatorAutomationPublish = (
      (operator.key === "dcg" || operator.key === "revcomps")
      && !paused
      && settings.publish_enabled === true
    );
    supports.operatorAutomationExpire = (
      (operator.key === "dcg" || operator.key === "revcomps")
      && !paused
      && settings.expire_enabled === true
    );
    supports.operatorAutomationScheduler = (
      (operator.key === "dcg" || operator.key === "elite" || operator.key === "revcomps")
      && !paused
      && settings.scheduler_enabled === true
    );
    if (operator.key === "botb") {
      supports.supportsScanDiagnostics = true;
      supports.scanOnly = false;
      supports.canRunScan = !paused;
      supports.canRunWritePhases = false;
      supports.operatorAutomationExpiryDryRun = !paused;
      supports.botbPublicCataloguePublish = !paused;
      supports.operatorAutomation = !paused && (
        settings.scan_enabled === true
        || settings.dry_run_enabled === true
        || supports.supportsScanDiagnostics === true
        || supports.operatorAutomationExpiryDryRun === true
        || supports.botbPublicCataloguePublish === true
      );
      supports.operatorAutomationApply = false;
      supports.operatorAutomationVerify = false;
      supports.operatorAutomationPublish = false;
      supports.operatorAutomationExpire = !paused && settings.expire_enabled === true;
      supports.operatorAutomationScheduler = !paused && settings.scheduler_enabled === true;
      supports.trustedAutomation = false;
      supports.dcgV2 = false;
      supports.liveListingDryRun = false;
      supports.liveListingApply = false;
    }
  }
  if (operator.key === "llf") {
    supports.trustedAutomation = false;
    supports.liveListingDryRun = false;
    supports.liveListingApply = false;
    supports.operatorAutomation = true;
    supports.supportsScanDiagnostics = true;
    supports.scanOnly = false;
    supports.canRunScan = true;
    supports.canRunWritePhases = false;
    supports.operatorAutomationApply = !paused && settings.apply_enabled === true;
    supports.operatorAutomationVerify = !paused && settings.verify_enabled === true;
    supports.operatorAutomationPublish = !paused && settings.publish_enabled === true;
    supports.operatorAutomationExpiryDryRun = !paused;
    supports.operatorAutomationExpire = !paused && settings.expire_enabled === true;
    supports.operatorAutomationScheduler = !paused && settings.scheduler_enabled === true;
  }
  if (operator.key === "dcg") {
    supports.trustedAutomation = false;
    supports.dcgV2 = true;
  }
  if (operator.key === "7days") {
    supports.supportsScanDiagnostics = true;
    supports.scanOnly = true;
    supports.canRunScan = !paused;
    supports.canRunWritePhases = false;
    supports.operatorAutomation = !paused && (
      settings.scan_enabled === true
      || settings.dry_run_enabled === true
      || settings.apply_enabled === true
      || settings.verify_enabled === true
      || settings.publish_enabled === true
      || settings.expire_enabled === true
      || settings.scheduler_enabled === true
      || supports.supportsScanDiagnostics === true
    );
    supports.operatorAutomationApply = !paused && settings.apply_enabled === true;
    supports.operatorAutomationVerify = !paused && settings.verify_enabled === true;
    supports.operatorAutomationPublish = !paused && settings.publish_enabled === true;
    supports.operatorAutomationExpire = !paused && settings.expire_enabled === true;
    supports.operatorAutomationScheduler = !paused && settings.scheduler_enabled === true;
    supports.trustedAutomation = false;
    supports.dcgV2 = false;
    supports.liveListingDryRun = false;
    supports.liveListingApply = false;
  }
  if (operator.key === "click") {
    supports.liveListingDryRun = false;
    supports.liveListingApply = false;
    supports.operatorAutomation = true;
    supports.supportsScanDiagnostics = true;
    supports.scanOnly = false;
    supports.canRunScan = true;
    supports.canRunWritePhases = false;
    supports.operatorAutomationApply = !paused && settings.apply_enabled === true;
    supports.operatorAutomationVerify = !paused && settings.verify_enabled === true;
    supports.operatorAutomationPublish = !paused && settings.publish_enabled === true;
    supports.operatorAutomationExpire = !paused && settings.expire_enabled === true;
    supports.operatorAutomationScheduler = !paused && settings.scheduler_enabled === true;
    supports.trustedAutomation = false;
  }
  if (operator.key === "jonnyfromdonny") {
    supports.liveListingDryRun = false;
    supports.liveListingApply = false;
    supports.operatorAutomation = true;
    supports.supportsScanDiagnostics = true;
    supports.scanOnly = true;
    supports.canRunScan = true;
    supports.canRunWritePhases = false;
    supports.operatorAutomationApply = false;
    supports.operatorAutomationVerify = false;
    supports.operatorAutomationPublish = false;
    supports.operatorAutomationExpiryDryRun = false;
    supports.operatorAutomationExpire = false;
    supports.operatorAutomationScheduler = false;
    supports.trustedAutomation = false;
  }
  if (operator.key === "feelgood") {
    supports.liveListingDryRun = false;
    supports.liveListingApply = false;
    supports.operatorAutomation = true;
    supports.supportsScanDiagnostics = true;
    supports.scanOnly = true;
    supports.canRunScan = true;
    supports.canRunWritePhases = false;
    supports.operatorAutomationApply = false;
    supports.operatorAutomationVerify = false;
    supports.operatorAutomationPublish = false;
    supports.operatorAutomationExpire = false;
    supports.operatorAutomationScheduler = false;
    supports.trustedAutomation = false;
  }
  if (operator.key === "aspire") {
    supports.liveListingDryRun = false;
    supports.liveListingApply = false;
    supports.operatorAutomation = true;
    supports.supportsScanDiagnostics = true;
    supports.scanOnly = false;
    supports.canRunScan = true;
    supports.canRunWritePhases = false;
    supports.operatorAutomationApply = !paused && settings.apply_enabled === true;
    supports.operatorAutomationVerify = !paused && settings.verify_enabled === true;
    supports.operatorAutomationPublish = !paused && settings.publish_enabled === true;
    supports.operatorAutomationExpiryDryRun = !paused;
    supports.operatorAutomationExpire = (
      !paused && !aspireLegacyMode && settings.expire_enabled === true
    );
    supports.operatorAutomationScheduler = (
      !paused && !aspireLegacyMode && settings.scheduler_enabled === true
    );
    supports.trustedAutomation = false;
  }
  if (operator.key === "mckinney") {
    supports.liveListingDryRun = false;
    supports.liveListingApply = false;
    supports.operatorAutomation = true;
    supports.supportsScanDiagnostics = true;
    supports.scanOnly = false;
    supports.canRunScan = true;
    supports.canRunWritePhases = false;
    supports.operatorAutomationApply = !paused && settings.apply_enabled === true;
    supports.operatorAutomationVerify = !paused && settings.verify_enabled === true;
    supports.operatorAutomationPublish = !paused && settings.publish_enabled === true;
    supports.operatorAutomationExpiryDryRun = !paused;
    supports.operatorAutomationExpire = !paused && settings.expire_enabled === true;
    supports.operatorAutomationScheduler = !paused && settings.scheduler_enabled === true;
    supports.trustedAutomation = true;
  }
  if (["kilted", "ukcc", "bounty", "storm", "redline", "prizeparadise", "apex", "jammy", "pawsome", "lincolnshire", "drift", "palladium", "pristine", "caddy", "hotcomps", "thatprizeguy", "giveawayguys", "bright", "salexmo"].includes(operator.key)) {
    supports.liveListingDryRun = false;
    supports.liveListingApply = false;
    supports.operatorAutomation = true;
    supports.supportsScanDiagnostics = true;
    supports.scanOnly = false;
    supports.canRunScan = true;
    supports.canRunWritePhases = false;
    supports.operatorAutomationApply = !paused && settings.apply_enabled === true;
    supports.operatorAutomationVerify = !paused && settings.verify_enabled === true;
    supports.operatorAutomationPublish = !paused && settings.publish_enabled === true;
    supports.operatorAutomationExpiryDryRun = !paused;
    supports.operatorAutomationExpire = !paused && settings.expire_enabled === true;
    supports.operatorAutomationScheduler = !paused && settings.scheduler_enabled === true;
    supports.trustedAutomation = false;
  }

  return {
    ...operator,
    mode,
    modeLabel: (operator.key === "jonnyfromdonny" || operator.key === "feelgood") && mode === "scan_only"
      ? "Scan dry-run only"
      : MODE_LABELS[mode] || operator.modeLabel,
    automationSettings: settings,
    lastRunAt: latestRun?.at || null,
    lastRunStatus: latestRun?.status ?? null,
    lastRunSource: latestRun?.source || null,
    lastRunLabel: "Last automation run",
    supports,
  };
}
